import { useState, useEffect } from "react";
import { TypographyFontSize } from "~/types/theme";

export const useTheme = () => {
  const [fontSizes, setFontSizes] = useState<TypographyFontSize>({
    fontSize: 16,
    fontSizeHeading1: 18,
    fontSizeHeading2: 17,
    fontSizeHeading3: 16,
    fontSizeHeading4: 15,
    fontSizeHeading5: 14,
  });

  useEffect(() => {
    const updateFontSize = () => {
      const width = window.innerWidth;

      if (width <= 1024) {
        setFontSizes({
          fontSize: 14,
          fontSizeHeading1: 18,
          fontSizeHeading2: 14,
          fontSizeHeading3: 13,
          fontSizeHeading4: 12,
          fontSizeHeading5: 11,
          iconSize: 21,
        });
      } else if (width <= 1440) {
        setFontSizes({
          fontSize: 14,
          fontSizeHeading1: 19,
          fontSizeHeading2: 15,
          fontSizeHeading3: 13,
          fontSizeHeading4: 12,
          fontSizeHeading5: 11,
          iconSize: 24,
        });
      } else if (width <= 1920) {
        setFontSizes({
          fontSize: 14,
          fontSizeHeading1: 20,
          fontSizeHeading2: 16,
          fontSizeHeading3: 14,
          fontSizeHeading4: 12,
          fontSizeHeading5: 11,
          iconSize: 24,
        });
      } else {
        setFontSizes({
          fontSize: 20,
          fontSizeHeading1: 26,
          fontSizeHeading2: 23,
          fontSizeHeading3: 17,
          fontSizeHeading4: 13,
          fontSizeHeading5: 12,
          iconSize: 30,
        });
      }
    };

    updateFontSize();
    window.addEventListener("resize", updateFontSize);

    return () => window.removeEventListener("resize", updateFontSize);
  }, []);

  return { fontSizes };
};
